import { ButtonGroup } from '@mui/material';
import { AddDocumentButton } from 'admin/documents/AddDocumentButton';
import { FileLinks } from 'admin/documents/FileLinks';
import { FinancialProductType, ProductBase } from 'generated/graphql';
import {
  ArrayField,
  BooleanField,
  BulkDeleteButton,
  Datagrid,
  DateField,
  DeleteButton,
  EditButton,
  FunctionField,
  ReferenceField,
  SelectField,
  SingleFieldList,
  TextField,
} from 'react-admin';

import { PRODUCT_STATUS_CHOICES } from './productUtils';

interface ProductDatagridProps {
  productType: FinancialProductType;
  showClient?: boolean;
}

export const ProductDatagrid: React.FC<ProductDatagridProps> = ({ productType, showClient }) => {
  return (
    <Datagrid
      bulkActionButtons={<BulkDeleteButton mutationMode="pessimistic" />}
      rowClick="show"
      sx={{
        '& .RaDatagrid-headerCell': {
          backgroundColor: '#eeeeee',
          width: '2em',
          wordBreak: 'break-all',
        },

        '& .RaDatagrid-rowCell > *': {
          display: 'block',
          minWidth: '100%',
        },
      }}
    >
      <TextField label="ID" source="id" width="3em" />
      {showClient && (
        <ReferenceField label="Klient" link="show" reference="Client" source="client.id">
          <TextField source="user.email" width="8em" />
        </ReferenceField>
      )}
      <FunctionField
        label="Inštitúcia"
        render={(record: ProductBase) => record.institution?.name ?? record.institutionName}
        width="8em"
      />
      <TextField label="Názov produktu" source="name" width="8em" />
      <SelectField choices={PRODUCT_STATUS_CHOICES} label="Status" source="status" width="8em" />
      <DateField label="Zmena stavu" locales="sk" source="statusChangeDate" width="6em" />
      <BooleanField label="Starostlivosť" noWrap={false} source="enableFinancialAdvisorCare" width="3em" />
      <ArrayField label="Dokumenty" source="documents">
        <SingleFieldList linkType={false} sx={{ width: '6em' }}>
          <ArrayField source="files">
            <FileLinks />
          </ArrayField>
        </SingleFieldList>
      </ArrayField>
      <ButtonGroup sx={{ textAlign: 'right', width: '12em' }}>
        <AddDocumentButton productType={productType} variant="text" />
        <EditButton centerRipple={true} variant="text" />
        <DeleteButton mutationMode="pessimistic" variant="text" />
      </ButtonGroup>
    </Datagrid>
  );
};
